import { ThemeProvider } from '@mui/material';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import { theme } from './_styles/theme.styles';
import { FormPageManage } from './pages/form/form-pageManage';
import Forms from './pages/form/form';
import { AppScreen } from './screens/app-screen';
import { SchoolBookingManage } from './pages/schoolBooking/schoolBooking-manage';
import { FormCompletedPage } from './pages/thankYou/formCompleted-page';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <Routes>
                    <Route path="" element={<AppScreen />}>
                        <Route path="/" element={<Navigate to="/Forms" replace />} />
                        <Route path="/Forms" element={<Forms />} />
                        <Route path="/Forms/:formId" element={<FormPageManage />} />
                        <Route path="/schoolBookingManage/:token" element={<SchoolBookingManage />} />
                        <Route path="/thankYou" element={<FormCompletedPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </ThemeProvider >
    );
}

export default App;
